import React from 'react';
import { Link } from 'react-router-dom';
import {
  Users, CalendarCheck, Settings, Banknote,
} from 'lucide-react';

function HrDashboard() {
  const cards = [
    {
      title: 'Employee List',
      icon: <Users className="h-6 w-6 text-blue-600" />,
      path: '/employee-list',
    },
    {
      title: 'Attendance Sheet',
      icon: <CalendarCheck className="h-6 w-6 text-green-600" />,
      path: '/attendance-sheet',
    },
    {
      title: 'Payroll',
      icon: <Banknote className="h-6 w-6 text-yellow-600" />,
      path: '/payroll',
    },
    {
      title: 'Payroll Monthly',
      icon: <Banknote className="h-6 w-6 text-yellow-600" />,
      path: '/payroll-monthly',
    },
    {
      title: 'New Employee Form',
      icon: <Users className="h-6 w-6 text-blue-600" />,
      path: '/new-employee',
    },
    {
      title: 'Payroll Settings',
      icon: <Settings className="h-6 w-6 text-gray-600" />,
      path: '/payroll-settings',
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">👥 HR Module</h2>
        <p className="text-sm text-gray-500">Manage employees, attendance and payroll efficiently.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((card) => (
          <Link
            to={card.path}
            key={card.title}
            className="group bg-white border shadow-sm rounded-2xl p-5 flex items-center space-x-4 hover:shadow-md hover:border-blue-500 transition duration-200"
          >
            <div className="bg-gray-100 p-3 rounded-full group-hover:scale-105 transition">{card.icon}</div>
            <div>
              <h3 className="text-base font-semibold text-gray-700 group-hover:text-blue-600">{card.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default HrDashboard;
